import axios from './api';
import { getQueryData, getUrl } from './utils';

const getEndPoint = (model) =>
  getUrl('api') +
  '/api/v2/' +
  (['delivery', 'ScannedDocuments', 'laboratory'].includes(model)
    ? 'ScannedDocuments'
    : 'ScannedDocumentsPC');

const getScannedDocumentByMysqlID = (id, model = 'delivery') =>
  axios.get(getEndPoint(model).concat('?mysqlId=', id), {}).then((res) => res);

const getScannedDocumentByMysqlIDAndPid = (id, pid, model = 'delivery') =>
  axios
    .get(getEndPoint(model).concat('?mysqlId=', id, '&pid=', pid), {})
    .then((res) => res);

const getScannedDocumentByMysqlIDAndPidAndModel = (
  id,
  pid,
  model = 'delivery',
) =>
  axios
    .get(
      getEndPoint(model).concat(
        '?mysqlId=',
        id,
        '&pid=',
        pid,
        '&model=',
        model,
      ),
      {},
    )
    .then((res) => res);

const getScannedDocument = (id, model = 'delivery') =>
  axios
    .get(getEndPoint(model).concat('/', id), {})
    .then((res) => res)
    .catch((error) => error.response);

const getScannedDocuments = async (
  { page, size, filters },
  model = 'delivery',
) => {
  return axios
    .get(getEndPoint(model).concat('/', getQueryData(page, size, filters)), {})
    .then((res) => res)
    .catch((error) => error.response);
};

const createScannedDocument = (scannedDocument, model = 'delivery') =>
  axios.post(
    getEndPoint(model).concat('/', model !== 'deliveryPC' ? model : ''),
    scannedDocument,
    {},
  );

const updateScannedDocument = (id, scannedDocument, model = 'delivery') =>
  axios.put(
    getEndPoint(model).concat(
      '/',
      model !== 'deliveryPC' ? model + '/' + id : id,
    ),
    scannedDocument,
    {},
  );

const deleteScannedDocument = ({ id }, model = 'delivery') =>
  axios
    .delete(getEndPoint(model).concat('/', id), {})
    .then((res) => res)
    .catch((error) => error.response);

export {
  createScannedDocument,
  deleteScannedDocument,
  getScannedDocument,
  getScannedDocumentByMysqlID,
  getScannedDocuments,
  updateScannedDocument,
  getScannedDocumentByMysqlIDAndPid,
  getScannedDocumentByMysqlIDAndPidAndModel,
};
